export enum FrontDisplayModes {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}
